<template>
  <div>
    <div class="top-haeding" v-if="usersData">
      <div
        class="flex w-full bg-img vx-row no-gutter items-center justify-center"
      >
        <div class="vx-col sm:w-full md:w-full lg:w-full xl:w-full">
          <h1 style="margin-bottom: 5px">
            {{ usersData.name }} {{ usersData.last_name }}
          </h1>
          <h6 style="color: #818181">
            Phone No: {{ usersData.phone }}, Driver ID:
            {{ usersData.id }}
          </h6>
        </div>
        <div
          style="display: flex"
          class="vx-col mt-5 sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2"
        >
          <div
            v-if="usersData.logs"
            class="flex w-full bg-img vx-row no-gutter items-center justify-center"
          >
            <vue-easy-pie-chart
              class="vx-col md:w-1/4 lg:w-1/4 xl:w-1/4"
              :percent="
                Math.floor((usersData.logs[0].untilbreak * 100) / 28800)
              "
            >
              <span style="display: flex; flex-direction: column">
                <span class="soat">{{
                  timeConvert(usersData.logs[0].untilbreak / 60)
                }}</span>
                <span class="label">Break</span>
              </span>
            </vue-easy-pie-chart>
            <vue-easy-pie-chart
              class="vx-col md:w-1/4 lg:w-1/4 xl:w-1/4"
              :percent="
                Math.floor((usersData.logs[0].driving_limit * 100) / 39600)
              "
            >
              <span style="display: flex; flex-direction: column">
                <span class="soat">{{
                  timeConvert(usersData.logs[0].driving_limit / 60)
                }}</span>
                <span class="label">Driving</span>
              </span>
            </vue-easy-pie-chart>
            <vue-easy-pie-chart
              class="vx-col md:w-1/4 lg:w-1/4 xl:w-1/4"
              :percent="Math.floor((usersData.logs[0].shift * 100) / 50400)"
            >
              <span style="display: flex; flex-direction: column">
                <span class="soat">{{
                  timeConvert(usersData.logs[0].shift / 60)
                }}</span>
                <span class="label">Shift</span>
              </span>
            </vue-easy-pie-chart>
            <vue-easy-pie-chart
              class="vx-col md:w-1/4 lg:w-1/4 xl:w-1/4"
              :percent="Math.floor((usersData.logs[0].cycle * 100) / 252000)"
            >
              <span style="display: flex; flex-direction: column">
                <span class="soat">{{
                  timeConvert(usersData.logs[0].cycle / 60)
                }}</span>
                <span class="label">Cycle </span>
              </span>
            </vue-easy-pie-chart>
          </div>
        </div>
        <div class="vx-col mt-5 sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2">
          <div class="eld">
            <vs-button
              class="float-right px-4 w-full md:w-auto mt-3 md:mt-0 md:mb-0"
              :to="'/daily-report/' + usersData.logs[0].id"
              >Report
            </vs-button>
            <vs-button
              @click="history = true"
              style="
                background: #f5f5f5 !important;
                color: rgba(0, 0, 0, 0.87);
                box-shadow: 0 1px 2px 0 rgb(0 0 0 / 14%),
                  0 2px 1px -2px rgb(0 0 0 / 20%), 0 1px 2px 0 rgb(0 0 0 / 12%);
              "
              class="float-right px-4 lg:mr-2 md:mr-2 xl:mr-2 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0"
            >
              History
            </vs-button>
            <!-- <vs-popup
              class="holamundo"
              title="Suggestions History"
              :active.sync="history"
            >
              <vs-table>
                <vs-th> Created </vs-th>
                <vs-th> Status </vs-th>
                <vs-tr>
                  <vs-td> 7/5/2021 6:25 AM PST </vs-td>
                  <vs-td class="text-success"> Approved </vs-td>
                </vs-tr>
              </vs-table>
            </vs-popup> -->
          </div>
        </div>
      </div>
    </div>
    <div class="tab-pane">
      <div
        class="flex w-full bg-img vx-row no-gutter items-center justify-center"
      >
        <div class="vx-col md:w-full lg:w-1/2 xl:w-1/2">
          <div style="padding: 1.2px !important" class="p-0">
            <div class="table-responsive mb-n">
              <table class="eld-log-summary table mb-n">
                <tbody>
                  <tr>
                    <th>Date</th>
                    <td class="text-center">
                      {{ $dayjs(usersData.created).format("DD-MM-YYYY") }}
                    </td>
                    <th>Worked Hours Today</th>
                    <td>
                      <span v-if="usersData.logs">
                        {{
                          new Date(usersData.logs[0].worked_hours * 1000)
                            .toUTCString()
                            .match(/(\d\d:\d\d:\d\d)/)[0]
                        }}
                      </span>
                    </td>
                    <th>Errors &amp; Violations</th>
                    <td class="text-danger">
                      {{ usersData.errors || "-" }} &amp;
                      {{ usersData.driving_in_violation || "-" }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="vx-col md:w-full lg:w-1/2 xl:w-1/2">
          <vs-button
            @click.ctrl="setNextDate('blank')"
            @click.stop="setNextDate('dafault')"
            @mousedown="setNextDate('next', $event)"
            style="
              background: #f5f5f5 !important;
              color: rgba(0, 0, 0, 0.87);
              box-shadow: 0 1px 2px 0 rgb(0 0 0 / 14%),
                0 2px 1px -2px rgb(0 0 0 / 20%), 0 1px 2px 0 rgb(0 0 0 / 12%);
            "
            class="float-right px-4 md:mr-2 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0"
            >Next Day</vs-button
          >
          <vs-button
            @click.ctrl="setPreviousDate('blank')"
            @click.stop="setPreviousDate('dafault')"
            @mousedown="setPreviousDate('next', $event)"
            style="
              background: #f5f5f5 !important;
              color: rgba(0, 0, 0, 0.87);
              box-shadow: 0 1px 2px 0 rgb(0 0 0 / 14%),
                0 2px 1px -2px rgb(0 0 0 / 20%), 0 1px 2px 0 rgb(0 0 0 / 12%);
            "
            class="float-right px-4 md:mr-2 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0"
            >Previous Day
          </vs-button>
        </div>
        <vx-card title="LOG EVENTS" class="mt-5" collapse-action>
          <line-svg :all="driverLogs" @active="changeActive"></line-svg>
          <div
            class="table-responsive p-n scroll-content"
            tabindex="0"
            style="right: -17px; bottom: -17px"
          >
            <vs-table stripe :data="driverLogs" maxHeight="300px">
              <template slot="thead">
                <vs-th>#</vs-th>
                <vs-th>Status</vs-th>
                <vs-th>Time (PST)</vs-th>
                <vs-th>Duration</vs-th>
                <vs-th> Location</vs-th>
                <vs-th>Vehicle</vs-th>
                <vs-th>Odometer</vs-th>
                <vs-th> Eng. Hours</vs-th>
                <vs-th>Notes</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr
                  v-for="(info, i) in data"
                  :key="i"
                  class="transition-all"
                  :style="
                    activeLog == info.id
                      ? 'background: rgba(229, 28, 35, .1) !important'
                      : ''
                  "
                >
                  <vs-td> {{ i + 1 }} </vs-td>
                  <vs-td> {{ info.status }} </vs-td>
                  <vs-td>
                    {{ info.cr_time.substr(11, 5) }}
                    {{ info.cr_time.substr(11, 5) > "12:00" ? "PM" : "AM" }}
                  </vs-td>
                  <vs-td>
                    {{
                      new Date(info.dur * 1000)
                        .toUTCString()
                        .match(/(\d\d:\d\d:\d\d)/)[0]
                    }}
                  </vs-td>
                  <vs-td> {{ info.country }}</vs-td>
                  <vs-td> {{ info.vehicle }} </vs-td>
                  <vs-td> {{ info.odometer }} </vs-td>
                  <vs-td> {{ info.engine_hours }} </vs-td>
                  <vs-td> {{ info.note || "-" }} </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
        <vx-card
          title="PROFILE FORM"
          v-if="usersData !== null"
          class="mt-5"
          tabindex="3"
          collapse-action
        >
          <vs-table stripe :data="[]" noDataText="">
            <template slot-scope="{}">
              <vs-tr>
                <vs-th> Driver </vs-th>
                <vs-td> {{ usersData.name }} {{ usersData.last_name }} </vs-td>
                <vs-th> Co-Drivers </vs-th>
                <vs-td> {{ usersData.co_driver || "d" }} </vs-td>
              </vs-tr>
              <vs-tr>
                <vs-th> Carrier </vs-th>
                <vs-td> {{ usersData.carrier }} </vs-td>
                <vs-th> Vehicles </vs-th>
                <vs-td> {{ usersData.vehicles }} (3AKJGLD5XGSGT0155) </vs-td>
              </vs-tr>
              <vs-tr>
                <vs-th> Main Office </vs-th>
                <vs-td>{{ usersData.main_ofice }} </vs-td>
                <vs-th> Trailers </vs-th>
                <vs-td>
                  <span v-for="(trailer, i) in usersData.trailers" :key="i">
                    {{ trailer }},
                  </span>
                </vs-td>
              </vs-tr>
              <vs-tr>
                <vs-th> Home Terminal </vs-th>
                <vs-td> {{ usersData.home_terminal_address }} </vs-td>
                <vs-th> Distance </vs-th>
                <vs-td>
                  {{ usersData.distance }} mi
                  <vs-button
                    @click="popupActive = true"
                    style="float: right; font-size: 11px; padding: 5px"
                    >Odometers
                  </vs-button>
                </vs-td>
              </vs-tr>
              <!-- <vs-tr>
                <vs-th> From Address </vs-th>
                <vs-td> {{ usersData.from_address }} </vs-td>
                <vs-th> To Address </vs-th>
                <vs-td> {{ usersData.to_address }} </vs-td>
              </vs-tr>
              <vs-tr>
                <vs-th> Shipping Docs </vs-th>
                <vs-td> {{ usersData.shipping_doc }} </vs-td>
                <vs-th> Notes </vs-th>
                <vs-td> {{ usersData.notes }} </vs-td>
              </vs-tr> -->
            </template>
            <template #notFound> Not Found </template>
          </vs-table>
        </vx-card>
        <vx-card title="Signature" class="mt-5" collapse-action>
          <div class="table-responsive mb-n flex items-center justify-around">
            <div class="vx-col">
              <div class="col-md-12 sign-row">
                <span class="vertical-align"
                  >I certify these entries are true and correct</span
                >
                <p v-if="usersData.sign">
                  Date:
                  {{
                    $dayjs(usersData.sign[0].created_date).format(
                      "dddd, DD MMM YYYY HH:mm A"
                    )
                  }}
                </p>
              </div>
            </div>
            <div class="vx-col">
              <div class="col-md-12 sign-row p-n text-center text-danger">
                <img
                  v-if="usersData.sign"
                  style="max-height: 100px"
                  :src="usersData.sign[0].sign"
                  alt="sign"
                />
                <div v-else class="col-md-12 vertical-align">
                  <div class="col-md-12 p-n">
                    <span class="has-bg material-icons">warning </span>
                  </div>
                  <div class="col-md-12 p-n">No Signature</div>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
        <vx-card title="DVIR" class="mt-5" collapse-action>
          <div
            class="table-responsive p-n scroll-content"
            tabindex="0"
            style="right: -17px; bottom: -17px"
          >
            <vs-table stripe :data="Dvirs">
              <template slot="thead">
                <vs-th>Date & Time (PST)</vs-th>
                <vs-th> Vehicle</vs-th>
                <vs-th> Status</vs-th>
                <vs-th> Description</vs-th>
                <vs-th> Signatures</vs-th>
                <vs-th></vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr v-for="(dvir, i) in data || []" :key="i">
                  <vs-td>
                    {{ dvir.time }}
                  </vs-td>
                  <vs-td>
                    {{ dvir.unit }}
                  </vs-td>
                  <vs-td>
                    <span v-for="(de, i) in dvir.defact || []" :key="i">
                      {{ de || "no" }}
                    </span>
                  </vs-td>
                  <vs-td>
                    {{ dvir.notes || "no decription" }}
                  </vs-td>
                  <vs-td>
                    {{ dvir.sign ? "Signatured" : "not signatured" }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
    </div>
    <!-- <vs-popup class="holamundo" title="Odometers" :active.sync="popupActive">
      <vs-table>
        <template slot="thead">
          <vs-th>Vehicle</vs-th>
          <vs-th>Start</vs-th>
          <vs-th>End</vs-th>
          <vs-th>Vehicle Miles</vs-th>
          <vs-th> Driver Miles</vs-th>
          <vs-th>PC/YM Miles</vs-th>
        </template>

        <template>
          <vs-tr>
            <vs-td> 1001 </vs-td>
            <vs-td> 584715 </vs-td>
            <vs-td> 584715 </vs-td>
            <vs-td> 0 </vs-td>
            <vs-td> 0 </vs-td>
            <vs-td> 0 </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup> -->
  </div>
</template>
<script>
import LineSvg from "./components/graph/Svg.vue";
import VueEasyPieChart from "vue-easy-pie-chart";
import "vue-easy-pie-chart/dist/vue-easy-pie-chart.css";
export default {
  components: {
    VueEasyPieChart,
    LineSvg,
  },
  computed: {
    usersData() {
      return this.$store.state.log.logDetail;
    },
    driverLogs() {
      return this.$store.state.event.driver_logs;
    },
    Dvirs() {
      return this.$store.state.event.dvirs;
    },
    General() {
      return this.$store.state.event.general;
    },
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_MEDIA,
      popupActive: false,
      history: false,
      isCtrlPressed: false,
      activeLog: null,
      isCtrl: false,
    };
  },
  methods: {
    timeConvert(n) {
      var num = n;
      var hours = num / 60;
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      if (rminutes < 10) {
        rminutes = "0" + rminutes;
      }
      if (rhours < 10) {
        rhours = "0" + rhours;
      }
      return rhours + ":" + rminutes;
    },
    setNextDate(openType, event) {
      const currentDate = new Date(this.$route.query.date);
      const nextDate = new Date(currentDate.getTime() + 24 * 60 * 60 * 1000); // Add one day (in milliseconds)
      if (openType == "dafault" && !this.isCtrlPressed) {
        this.$router.push({
          path: "",
          query: {
            date: nextDate.toISOString().split("T")[0],
          },
        });
        this.fetchData();
      } else if (event.button === 1) {
        const url = `${window.location.origin}/driver-logs/${
          this.$route.params.id
        }?date=${nextDate.toISOString().split("T")[0]}`;
        window.open(url, "_blank");
      } else {
        this.isCtrlPressed = true;
        const url = `${window.location.origin}/driver-logs/${
          this.$route.params.id
        }?date=${nextDate.toISOString().split("T")[0]}`;
        window.open(url, "_blank");
        setTimeout(() => {
          this.isCtrlPressed = false;
        }, 1000);
      }
    },
    setPreviousDate(openType, event) {
      const currentDate = new Date(this.$route.query.date || new Date());
      const previousDate = new Date(
        currentDate.getTime() - 24 * 60 * 60 * 1000
      ); // Subtract one day (in milliseconds)
      if (openType == "dafault" && !this.isCtrlPressed) {
        this.$router.push({
          path: "",
          query: {
            date: previousDate.toISOString().split("T")[0],
          },
        });
        this.fetchData();
      } else if (event.button === 1) {
        const url = `${window.location.origin}/driver-logs/${
          this.$route.params.id
        }?date=${previousDate.toISOString().split("T")[0]}`;
        window.open(url, "_blank");
      } else {
        this.isCtrlPressed = true;
        const url = `${window.location.origin}/driver-logs/${
          this.$route.params.id
        }?date=${previousDate.toISOString().split("T")[0]}`;
        window.open(url, "_blank");
        setTimeout(() => {
          this.isCtrlPressed = false;
        }, 1000);
      }
    },
    async fetchData() {
      this.$vs.loading();
      await this.$store
        .dispatch("log/fetchDataLogDetail", {
          id: this.$route.params.id,
          date: this.$route.query.date,
        })
        .then((res) =>
          this.$store.dispatch("event/fetchDataEvents", {
            driver_id: this.$route.params.id,
            log_id: res.data.logs[0].id,
          })
        );
      await this.$store.dispatch("event/fetchDataDvirs", this.$route.params.id);
      this.connection = new WebSocket(
        `${
          process.env.VUE_APP_SOCKET
        }/log/by/driver/?token=${localStorage.getItem("access")}&driver_id=${
          this.$route.params.id
        }&date=${this.$route.query.date}`
      );
      // let self = this;
      // this.connection.onmessage = (event) => {
      //   let data = JSON.parse(event.data);
      //   console.log(data);
      //   self.$store.commit("eventsList/SET_DRIVER_STATUS", data.datas);
      //   if (!this.dataFetched) {
      //     this.dataFetched = true;
      //   }
      // };
      // this.connection.onclose = function (event) {
      //   if (event.wasClean) {
      //     console.log(
      //       event,
      //       `[close] Connection closed cleanly, code=${event.code} reason=${event}`
      //     );
      //   } else {
      //     console.log("[close] Connection died");
      //   }
      // };
      this.$vs.loading.close();
    },
    changeActive(log) {
      this.activeLog = log;
    },
  },
  mounted() {
    this.fetchData();
    // this.$store.dispatch("eventsList/fetchDataGeneral", this.$route.params.id);
  },
};
</script>
<style lang="css" scoped>
.p-0 {
  background: #fff;
  border-radius: 0.5rem;
  box-shadow: 0px 4px 25px 0px rgb(0 0 0 / 10%);
  -webkit-transition: all 0.3s ease-in-out;
}

.soat {
  font-size: 25px;
  line-height: 2;
  margin-top: 23px;
}

.label {
  line-height: 0;
  font-size: 15px;
}

body {
  background: #f5f5f5;
}

[dir] .vx-card .vx-card__collapsible-content .vx-card__body {
  padding: 0rem;
}

/* @import url('https://app.gpstab.com//assets/bundles/main?h=e9f6514fb21326ddd7d2156755e004b7'); */
</style>

